import React, { useContext, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Badge, IconButton, makeStyles, Menu, MenuItem } from '@material-ui/core';
import { Notifications } from '@material-ui/icons';
import { path as getPageMyNotificationListPath } from 'pages/PageMyNotificationList';
import { path as getPageMyNotificationPprListPath } from 'pages/PageMyNotificationPprList';
import { NotificationsContext } from 'providers/NotificationsProvider';

const useStyles = makeStyles(() => ({
  badge: {
    animation: 'blinker 500ms linear infinite',
  },

  '@keyframes ripple': {
    '50%': {
      opacity: 0,
    },
  },
}));

const NotificationsButton = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const { hasNotifications } = useContext(NotificationsContext);
  const classes = useStyles();

  return (
    <>
      <IconButton size="small" onClick={(event) => setAnchorEl(event.currentTarget)} aria-label="Уведомления">
        <Badge color="secondary" invisible={!hasNotifications} classes={{ badge: classes.badge }} variant="dot">
          <Notifications style={{ color: '#fff', fontSize: 28 }} />
        </Badge>
      </IconButton>

      <Menu
        id="notifications-menu"
        keepMounted
        open={Boolean(anchorEl)}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem component={RouterLink} to={getPageMyNotificationListPath} onClick={() => setAnchorEl(null)}>
          Сервис
        </MenuItem>

        <MenuItem component={RouterLink} to={getPageMyNotificationPprListPath} onClick={() => setAnchorEl(null)}>
          ППР
        </MenuItem>
      </Menu>
    </>
  );
};

export default NotificationsButton;
